import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'ISSUES',
    itemActionName: 'ISSUE',
});
